module.exports = __webpack_public_path__ + "b23b30655a4205123392baa1366b8855.fbx";